export const SERVER_URL = process.env.REACT_APP_SERVER_URL

export const SERVER_CREDENTIALS = btoa(`${process.env.REACT_APP_SERVER_USERNAME}:${process.env.REACT_APP_SERVER_PASSWORD}`) 


export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const AUTH_URL = process.env.REACT_APP_AUTH_URL